import React from "react";
import { program } from "@/interfaces/Workshop";

interface ModalProps {
  program: program | null;
  onClose: () => void;
}

const ProgramDetailModal = ({ program, onClose }: ModalProps) => {
  if (!program) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="relative w-full max-w-4xl bg-white rounded-lg shadow-xl">

        {/* HEADER */}
        <div className="flex items-center justify-between p-6">
          <h2 className="text-lg md:text-2xl font-bold text-gray-800 max-w-[75%]">
            {program.title}
          </h2>

          <a
            href="https://wa.me/6281215636018"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-teal-600 text-white px-5 py-2 rounded font-semibold hover:bg-black transition"
          >
            Daftar Sekarang
          </a>
        </div>

        {/* Tombol Close */}
        <button
          onClick={onClose}
          className="absolute -top-5 -right-2 md:-right-5 w-10 h-10 flex items-center justify-center font-bold shadow-lg bg-gray-300 rounded-full text-gray-700 hover:bg-gray-400 hover:text-black text-3xl leading-none z-20"
        >
          <span className="relative -top-[3px]">&times;</span>
        </button>

        {/* CONTENT */}
        <div className="max-h-[70vh] overflow-y-auto p-6 md:p-8 text-sm text-gray-800 space-y-5">

          {/* DESKRIPSI */}
          <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
            <p className="font-semibold text-gray-500">Deskripsi</p>
            <p className="text-justify">{program.description}</p>
          </div>

          {/* DURASI */}
          <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
            <p className="font-semibold text-gray-500">Durasi</p>
            <p>{program.programduration}</p>
          </div>

          {/* WAKTU */}
          {program.jam && (
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
              <p className="font-semibold text-gray-500">Waktu</p>
              <p>{program.jam}</p>
            </div>
          )}

          {/* TARGET PESERTA */}
          {program.targetParticipants && program.targetParticipants.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
              <p className="font-semibold text-gray-500">Target Peserta</p>
              <div>
                <p className="text-gray-800 mb-1">Peserta :</p>
                <ul className="list-disc pl-5 space-y-1">
                  {program.targetParticipants.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* TUJUAN PROGRAM */}
          {program.tujuanProgram && program.tujuanProgram.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
              <p className="font-semibold text-gray-500">Tujuan Program</p>
              <div>
                <p className="text-gray-800 mb-1">Peserta Mampu Untuk :</p>
                <ul className="list-disc pl-5 space-y-1">
                  {program.tujuanProgram.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* METODE PEMBELAJARAN */}
          {program.metodePembelajaran &&
            program.metodePembelajaran.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
                <p className="font-semibold text-gray-500">
                  Metode Pembelajaran
                </p>
                <div>
                  <p className="text-gray-800 mb-1">Metode :</p>
                  <ul className="list-disc pl-5 space-y-1">
                    {program.metodePembelajaran.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

          {program.unitKompetensi &&
            program.unitKompetensi.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
                <p className="font-semibold text-gray-500">
                  Skema Unit Kompetensi
                </p>
                <div>
                  <p className="text-gray-800 mb-1">Skema Unit Kompetensi Uji Sertifikasi BNSP :</p>
                  <ul className="list-disc pl-5 space-y-1">
                    {program.unitKompetensi.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

          {/* BIAYA */}
          {program.price &&
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
              <p className="font-semibold text-gray-500">Harga</p>
              <p className="text-red-600 font-bold">{program.price}</p>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default ProgramDetailModal;
